export default __webpack_public_path__ + "static/media/arrow_warning_blue.23d99903.svg";